var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArbitrumGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64872 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64872 23.5 12Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.107 19.5665L5.30497 15.7986L5.27281 8.20902L12.107 4.43347L18.9492 8.21672V15.7832L12.107 19.5665Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1844 8.63464L7.85875 17.2182L10.504 18.5743L14.7733 8.63464H12.1763H12.1844Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1271 9.328L19.099 13.8818L18.311 16.0932L14.3392 11.5394L15.1271 9.328Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.913 11.9478L13.1251 14.1591L16.1 17.7266L16.0758 17.7498H16.116L16.1 17.7266L17.6758 16.5015L13.913 11.9478Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2688 9.51304L5.26176 14.9144L6.99041 16.9177L11.316 8.63464H9.79644C9.16126 8.63464 8.57433 8.97367 8.2688 9.51304Z",
    fill: "#020202"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_82"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrumGrey);
export default __webpack_public_path__ + "static/media/arbitrum_grey.88e86854.svg";
export { ForwardRef as ReactComponent };